import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { TranslateModule } from '@ngx-translate/core';
import { ResellerActionsComponent } from './reseller-actions/reseller-actions/reseller-actions.component';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MoovCommonModule } from '../moov-common/moov-common.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';



@NgModule({
  declarations: [
    ResellerActionsComponent
  ],
  imports: [
    CommonModule,
    MoovCommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatDividerModule,
    MatSlideToggleModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatListModule,
    ClipboardModule,
    TranslateModule,
    MatTooltipModule,
    MatSelectModule,
    MatMenuModule
  ]
})
export class ResellerViewModule { }
